import React from 'react';
import propTypes from 'prop-types';
import { sanitizeDirtyHTML } from 'helpers/strings';
import { cn } from 'lib/utils';

// base typography for rich text coming from Zoho (links, lists, paragraphs)
const HTML_CONTENT_CLASSES =
  '[&_a]:font-medium [&_a]:text-primary-emphasis-light [&_a]:no-underline hover:[&_a]:underline [&_ol]:my-1.5 [&_ol]:pl-[18px] [&_p]:my-1.5 [&_p]:first:mt-0 [&_p]:last:mb-0 [&_ul]:my-1.5 [&_ul]:pl-[18px]';

/**
 * renders a rich text string as sanitized HTML with base typography styles
 * @param html - raw HTML (or plain text) string to render
 * @param className - extra classes for the wrapper element
 * @param as - wrapper element to render, defaults to div
 */
export default function HtmlContent({ html, className, as: Wrapper = 'div' }) {
  if (!html) return null;

  return (
    <Wrapper
      className={cn(HTML_CONTENT_CLASSES, className)}
      dangerouslySetInnerHTML={sanitizeDirtyHTML(html)}
    />
  );
}

HtmlContent.propTypes = {
  html: propTypes.string,
  className: propTypes.string,
  as: propTypes.elementType
};
